import { Request } from "express";
import { History } from 'history';
import { TApp } from "./types";

const getAppName = (pathname: string) => {
    if (pathname.indexOf("/memory") !== -1) {
        return "memory";
    }
    if (pathname.indexOf("/choir") !== -1) {
        return "choir";
    }
    return undefined;
}

export const getAppFromReferer = (req: Request): TApp | undefined => {
    const { referer } = req.headers;
    return getAppName(referer);
};

export const getAppFromHistory = (history: History): TApp | undefined => {
    const { pathname } = history.location;
    return getAppName(pathname);
}

export const getAppPrefix = (app: TApp | undefined) => {
    return app ? `/${app}` : '';
}
